export default __webpack_public_path__ + "static/media/underProcess.c925adef.svg";